var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"main"},[_c('v-img',{staticClass:"imagem",attrs:{"max-height":"110","max-width":"110","src":require("@/assets/atomo.png")}}),_c('h2',{staticClass:"titulo"},[_vm._v("Selecione uma equação para começar...")])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }